var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timerStr)?_c('div',{staticClass:"line-timer-wrapper",on:{"click":_vm.goTo}},[_vm._v(" Your test result is coming in "+_vm._s(_vm.timerStr)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }